import {useState, useEffect, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Routes, Route, Outlet, Navigate, useLocation, useNavigate} from 'react-router-dom'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {GetAllComment} from '../../../../Redux/AdminPanel/CommentSlice'
import {QuickMsg} from '../../../../Redux/AdminPanel/QuickMessageSlice'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {UpdateStatusStaff} from '../../MyProfile/Staff_Account/StaffAccountSlice/StaffAccountSlice'
import {DeleteWhitelableUser} from '../WhiteLabelSlice/WhiteLabelSlice'
import WhiteLabelProfile from './WhiteLabelProfile'
import {UpdateWhiteLabelStatus} from './WhiteLabelProfileSlice/WhiteLAbelSlice'
import WhiteLabelCredit from './WhiteLabelSubTab/WhiteLabelCredit'
import WhiteLabelOverview from './WhiteLabelSubTab/WhiteLabelOverview'
import WhiteLabelUserList from './WhiteLabelSubTab/WhiteLabelUserList'
import QuickMessageDrawerInner from '../../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'

const WhiteLabelProfileDetaile = () => {
  const param: any = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  //////////////////////////////////USESTATE HOOK///////////////////////////////////////////////
  const [notify, setNotify] = useState(false)
  const [deletePopup, setDeletePopup] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const [userId, setUserId] = useState<any>('')
  const [quickMessagePopup, setQuickMessagePopup] = useState(false)

  const ProfileDetatileState = useSelector(
    (state: any) => state?.ProfileData?.ProfileData?.items?.[0]
  )

  //////////////////////////////////USESTATE HOOK///////////////////////////////////////////////

  ////////////////////////////////////USESELECTOR ///////////////////////////////////////////////

  ////////////////////////////////////USESELECTOR ///////////////////////////////////////////////

  ////////////////////////////////////USE EFFECT HOOK ///////////////////////////////////////////////

  useEffect(() => {
    if (confirm == true) {
      dispatch(DeleteWhitelableUser({id: ProfileDetatileState?._id}))
      navigate('/whitelabel-list')
    }
  }, [confirm])

  ////////////////////////////////////USE EFFECT HOOK ///////////////////////////////////////////////

  ////////////////////////////////////USE MEMO HOOK USE FOR POPUP  ///////////////////////////////////////////////

  //   const notification = useMemo(
  //     () => <CreateNotification show={notify} handleClose={() => setNotify(false)} />,
  //     [notify]
  //   )
  const ConfirmDelete = useMemo(
    () => (
      <DeleteConfirmationPopup
        Message={'Are you sure you want to Delete this Profile'}
        show={deletePopup}
        confirm={() => setConfirm(true)}
        handleClose={() => setDeletePopup(false)}
      />
    ),
    [deletePopup]
  )

  ////////////////////////////////////USE MEMO HOOK USE FOR POPUP ///////////////////////////////////////////////

  ////////////////////////FUNTIONS FOR DIFFERENT OPERATIONS/////////////////////////////////////

  const handleCombineStatus = (status: string) => {
    dispatch(
      UpdateWhiteLabelStatus({
        id: ProfileDetatileState?._id,
        data: {
          userId: ProfileDetatileState?.user?._id,
          status2: status,
        },
      })
    )
  }

  ////////COMMENT PART HANDLE //////////////////////////////
  const handleComment = (id: string) => {
    dispatch(
      GetAllComment({
        userId: id,
      })
    )
  }

  const openQuickMessage = useMemo(
    () => (
      <QuickMessageDrawerInner
        handleClose={() => setQuickMessagePopup(false)}
        show={quickMessagePopup}
        contacts={[
          {value: ProfileDetatileState?.user?.mobile, label: ProfileDetatileState?.user?.mobile},
        ]}
        //  valid={valid} setValid={setValid} virtualNumber={virtualNumber}
      />
    ),
    [quickMessagePopup]
  )

  return (
    <>
      {AuthenticateUser('send-quick-sms') && quickMessagePopup && openQuickMessage}
      {ConfirmDelete}
      <Routes>
        <Route
          element={
            <>
              <div className='row'>
                <WhiteLabelProfile />
                <div className='col-md-8'>
                  <div className='d-flex justify-content-between'>
                    <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder'>
                      <li
                        className='nav-item cursor-pointer'
                        onClick={() => navigate('/whiteLabel-profile/whiteLabelOverview')}
                      >
                        <span
                          className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                            param?.pathname?.split('/').at(-1) == 'whiteLabelOverview' && 'active'
                          } `}
                        >
                          Overview
                        </span>
                      </li>

                      <li
                        className='nav-item cursor-pointer'
                        onClick={() => navigate('/whiteLabel-profile/whiteLabelCredit')}
                      >
                        <span
                          className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                            param?.pathname?.split('/').at(-1) == 'whiteLabelCredit' && 'active'
                          } `}
                        >
                          credits
                        </span>
                      </li>

                      <li
                        className='nav-item cursor-pointer'
                        onClick={() => navigate('/whiteLabel-profile/whiteLabelUserList')}
                      >
                        <span
                          className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                            param?.pathname?.split('/').at(-1) == 'whiteLabelUserList' && 'active'
                          } `}
                        >
                          WhiteLabel User
                        </span>
                      </li>
                    </ul>
                    <div className='d-flex my-4'>
                      <div className='me-0'>
                        <button
                          className='btn btn-primary'
                          data-kt-menu-trigger='click'
                          data-kt-menu-placement='bottom-end'
                        >
                          Actions
                          <span className='svg-icon svg-icon-primary svg-icon-2 ms-2 me-0'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              xmlnsXlink='http://www.w3.org/1999/xlink'
                              width='24px'
                              height='24px'
                              viewBox='0 0 24 24'
                              version='1.1'
                            >
                              <g stroke='none' strokeWidth={1} fill='none' fillRule='evenodd'>
                                <polygon points='0 0 24 0 24 24 0 24' />
                                <path
                                  d='M6.70710678,15.7071068 C6.31658249,16.0976311 5.68341751,16.0976311 5.29289322,15.7071068 C4.90236893,15.3165825 4.90236893,14.6834175 5.29289322,14.2928932 L11.2928932,8.29289322 C11.6714722,7.91431428 12.2810586,7.90106866 12.6757246,8.26284586 L18.6757246,13.7628459 C19.0828436,14.1360383 19.1103465,14.7686056 18.7371541,15.1757246 C18.3639617,15.5828436 17.7313944,15.6103465 17.3242754,15.2371541 L12.0300757,10.3841378 L6.70710678,15.7071068 Z'
                                  fill='#ffffff'
                                  fillRule='nonzero'
                                  transform='translate(12.000003, 11.999999) rotate(-180.000000) translate(-12.000003, -11.999999)'
                                />
                              </g>
                            </svg>
                          </span>
                        </button>
                        <div
                          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3'
                          data-kt-menu='true'
                          style={{}}
                        >
                          <div className='menu-item px-3'>
                            <div className='menu-content text-muted pb-2 px-3 fs-7 text-uppercase'>
                              Contact
                            </div>
                          </div>
                          <div className='menu-item px-3'>
                            {AuthenticateUser('send-quick-sms') && (
                              <div className='aside-footer flex-column-auto '>
                                <a
                                  target='_blank'
                                  className='menu-link px-3'
                                  data-bs-toggle='tooltip'
                                  data-bs-trigger='hover'
                                  data-bs-dismiss-='click'
                                  title='Check out the complete documentation with over 100 components'
                                  onClick={() => setQuickMessagePopup(true)}
                                >
                                  Send quick message
                                </a>
                                {/* <a href="#" className="menu-link px-3">Send quick message</a> */}
                              </div>
                            )}
                          </div>
                          <div className='menu-item px-3'>
                            <a
                              href={`mailto:${ProfileDetatileState?.user?.email}`}
                              className='menu-link px-3'
                            >
                              Send email
                            </a>
                          </div>
                          <div className='menu-item px-3'>
                            <span onClick={() => setNotify(true)} className='menu-link px-3'>
                              Add portal notification
                            </span>
                          </div>
                          <div className='separator my-2' />
                          <div className='menu-item px-3'>
                            <div className='menu-content text-muted pb-2 px-3 fs-7 text-uppercase'>
                              Account
                            </div>
                          </div>
                          <div
                            className='menu-item px-3'
                            data-kt-menu-trigger='hover'
                            data-kt-menu-placement='right-end'
                          >
                            <span className='menu-link'>
                              <span className='menu-title'>Status</span>
                              <span className='menu-arrow' />
                            </span>
                            <div className='menu-sub menu-sub-dropdown w-175px py-4'>
                              <div
                                className='menu-item px-3'
                                onClick={() => handleCombineStatus('active')}
                              >
                                <span className='menu-link px-3'>
                                  <span className='bg-success   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                  <span className='menu-title'>Active</span>
                                  {ProfileDetatileState?.user?.status2 == 'active' && (
                                    <span className='svg-icon svg-icon-primary'>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        xmlnsXlink='http://www.w3.org/1999/xlink'
                                        width='24px'
                                        height='24px'
                                        viewBox='0 0 24 24'
                                        version='1.1'
                                      >
                                        <g
                                          stroke='none'
                                          strokeWidth={1}
                                          fill='none'
                                          fillRule='evenodd'
                                        >
                                          <polygon points='0 0 24 0 24 24 0 24' />
                                          <path
                                            d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                            fill='#7950f2'
                                            fillRule='nonzero'
                                            transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  )}
                                </span>
                              </div>
                              <div
                                className='menu-item px-3'
                                onClick={() => handleCombineStatus('inactive')}
                              >
                                <span className='menu-link px-3'>
                                  <span className='bg-secondary   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                  <span className='menu-title'>Inactive</span>

                                  {ProfileDetatileState?.user?.status2 == 'inactive' && (
                                    <span className='svg-icon svg-icon-primary'>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        xmlnsXlink='http://www.w3.org/1999/xlink'
                                        width='24px'
                                        height='24px'
                                        viewBox='0 0 24 24'
                                        version='1.1'
                                      >
                                        <g
                                          stroke='none'
                                          strokeWidth={1}
                                          fill='none'
                                          fillRule='evenodd'
                                        >
                                          <polygon points='0 0 24 0 24 24 0 24' />
                                          <path
                                            d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                            fill='#7950f2'
                                            fillRule='nonzero'
                                            transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  )}
                                </span>
                              </div>
                              <div
                                className='menu-item px-3'
                                onClick={() => handleCombineStatus('suspended')}
                              >
                                <span className='menu-link px-3'>
                                  <span className='bg-danger   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                  <span className='menu-title'>Suspended</span>

                                  {ProfileDetatileState?.user?.status2 == 'suspended' && (
                                    <span className='svg-icon svg-icon-primary'>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        xmlnsXlink='http://www.w3.org/1999/xlink'
                                        width='24px'
                                        height='24px'
                                        viewBox='0 0 24 24'
                                        version='1.1'
                                      >
                                        <g
                                          stroke='none'
                                          strokeWidth={1}
                                          fill='none'
                                          fillRule='evenodd'
                                        >
                                          <polygon points='0 0 24 0 24 24 0 24' />
                                          <path
                                            d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                            fill='#7950f2'
                                            fillRule='nonzero'
                                            transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                          {AuthenticateUser('delete-whitelabel') && (
                            <div
                              className='menu-item px-3 my-1'
                              onClick={() => setDeletePopup(true)}
                            >
                              <a className='menu-link px-3 text-danger'>Delete client</a>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <Outlet />
                </div>
              </div>
            </>
          }
        >
          <Route
            index
            element={<Navigate to='/whiteLabel-profile/whiteLabelOverview' replace={true} />}
          />

          <Route
            path='whiteLabelOverview'
            element={
              <>
                <WhiteLabelOverview />
              </>
            }
          />
          <Route
            path='whiteLabelCredit'
            element={
              <>
                <WhiteLabelCredit />
              </>
            }
          />
          <Route
            path='whiteLabelUserList'
            element={
              <>
                <WhiteLabelUserList />
              </>
            }
          />
        </Route>
      </Routes>
    </>
  )
}

export default WhiteLabelProfileDetaile
